const arrayMenu = [
  [
    // MASTER
    {
      icon: 'home',
      path: '/home',
      label: 'Página inicial',
    },
    {
      icon: 'upload',
      path: '/CreateDocument',
      label: 'Revisão de Documento',
    },
    {
      icon: 'read',
      path: '/readDocument',
      label: 'Consultar Documentos',
    },
    {
      icon: 'alert',
      path: '/notice',
      label: 'Avisos',
    },
    {
      icon: 'training',
      path: '/training',
      label: 'Treinamento',
    },
    {
      icon: 'feed',
      path: '/report',
      label: 'Relatório ',
    },
    {
      icon: 'settings',
      path: '/settings',
      label: 'Configuração',
    },
  ],
  [
    // BASICO
    {
      icon: 'home',
      path: '/home',
      label: 'Página inicial',
    },
    {
      icon: 'read',
      path: '/readDocument',
      label: 'Consultar Documentos',
    },
    {
      icon: 'alert',
      path: '/notice',
      label: 'Avisos',
    },
    {
      icon: 'training',
      path: '/training',
      label: 'Treinamento',
    },
  ],
  [
    // CRIADOR DE DOCUMENTO
    {
      icon: 'home',
      path: '/home',
      label: 'Página inicial',
    },
    {
      icon: 'upload',
      path: '/CreateDocument',
      label: 'Revisão de Documento',
    },
    {
      icon: 'read',
      path: '/readDocument',
      label: 'Consultar Documentos',
    },
    {
      icon: 'alert',
      path: '/notice',
      label: 'Avisos',
    },
    {
      icon: 'training',
      path: '/training',
      label: 'Treinamento',
    },
  ],
];

export default arrayMenu;
